import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";
import { resolvePath } from "@utils/resolvePath";

export const DashcamContainer = styled(Box)`
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const BackgroundWrapper = styled(Box)<{ backgroundImage: string }>`
  background-image: url(${(props) => resolvePath(props.backgroundImage)});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
`;

export const ContentContainer = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

export const IntroducingContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
`;

export const IntroducingText = styled(Text)`
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.1px;
  text-transform: uppercase;
  background: linear-gradient(269deg, #F16262 -10.35%, #743DDC 106.34%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-left: 8px;
  margin-right: 8px;
  @media (min-width: 768px) {
    font-size: 16px;
    letter-spacing: 3px;
  }
`;

export const MainHeading = styled(Text)`
  color: var(--Purple-P500, #451999);
  text-align: center;
  font-family: "Euclid Circular B";
  font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.1px;
  white-space: pre-line;
  @media (min-width: 768px) {
    font-size: 36px;
    max-width: 400px;
    margin-bottom: 60px;
  }
`;

export const LogoContainer = styled(Box)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 40px;
`;

export const VideoBackground = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  object-fit: cover;
  z-index: 1;
  border-radius: 20px;
  clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
`;


export const RIcon = styled(Box)`
  position: absolute;
  bottom: -10px;
  right: 20px;
  
  @media (min-width: 768px) {
    bottom: -15px;
    right: 30px;
  }
`;

export const RIconCircle = styled(Box)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #FF6B35;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
  position: relative;
`;

export const RIconPointer = styled(Box)`
  position: absolute;
  bottom: -8px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #666;
  transform: translateX(-50%);
`;

export const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 185px;
`;